/**
 * Popup Modal Directive: can be used with anchors and buttons to popup a modal
 *
 * DO NOT CUSTOMIZE!!!
 *
 * - If you need custom features, use popup-site-ui-kit.component as a template
 *
 * - Reviewers: Do not approve any change specific only for a unique modal
 */

import { 
  Directive, 
  HostListener, 
  Input, 
  Output, 
  ElementRef,
  EventEmitter, 
  ViewChild} from '@angular/core';
import { PopupModalService } from "app/services/popup-modal.service";

@Directive({
  selector: '[popupModal]'
})

export class PopupModalDirective {

  constructor(private popupModalService:PopupModalService) { 
  }

  @ViewChild("popupModal") trigger: ElementRef;

  // == Input ONLY for custom Popup Content ==
  @Input() popupContentComponent: string = "";

  // Optional additional parameters passed to custom Popup Content
  @Input() popupContentParams: any = "";

  // Warning: if popup content, then everything below is ignored, don't try to mix input
  
  // == Input ONLY for MFA Modal ==
  @Input() mfaModalComponent: any = "";

  // Warning: if MFA modal, then everything below is ignored, don't try to mix input
 
  // == Input ONLY for standard Popup Modal ==
  // The name of the popup modal, used for Site Catalyst
  @Input() popupModalName: string = "";

  // The title text of the popup modal
  @Input() popupModalTitle: string = "";

  // The body text of the popup modal
  @Input() popupModalBody: string = "";

  // The text on the submit/accept button
  @Input() popupModalSubmit: string = "";

  // The ADA text in the submit/accept button
  @Input() ariaPopupModalSubmit: string = "";

  // The text on the cancel button
  @Input() popupModalCancel: string = "";

  // The ADA text in the cancel button
  @Input() ariaPopupModalCancel: string = "";

  // Whether or not the popup modal should contain a close icon
  @Input() popupModalHasCloseIcon: boolean = true;

  // aria-label attribute to the popup modal trigger button
  @Input() ariaPopupModalClose: string = "";

  @HostListener('click', ['$event']) onClick(clickEvent) {
    clickEvent.preventDefault();

    this.popupModalService.setTriggerElement.emit(this.trigger);

    // a popup content component
    if (this.popupContentComponent) {

      // if a content component property is given, this is a custom content modal
      // TBD: rename to popupContentName
      this.popupModalService.openPopupContent.emit({
        popupContentComponent:this.popupContentComponent,
        popupContentParams:this.popupContentParams
      });

    // a MFA Modal component
    } else if (this.mfaModalComponent) {

      // if a mfa modal component property is given, this is a MFA modal
      this.popupModalService.openMfaModalLibrary.emit({
        mfaModalComponent:this.mfaModalComponent
      });

    } else {  // this is a standard popup modal

      // use the parameters set above (see "Input ONLY for Popup Modal")
      /* FUTURE DEVELOPMENT
      this.popupModalService.openPopupModal.emit({ 
        popupModalName:this.popupModalName,
        popupModalBody:this.popupModalBody,
        popupModalTitle:this.popupModalTitle,
        popupModalSubmit:this.popupModalSubmit,
        ariaPopupModalSubmit:this.ariaPopupModalSubmit,
        popupModalCancel:this.popupModalCancel,
        ariaPopupModalCancel:this.ariaPopupModalCancel,
        popupModalHasCloseIcon:this.popupModalHasCloseIcon,
        ariaPopupModalClose:this.ariaPopupModalClose
      });
      */
    }
  }

}
